import RefreshIcon from '@mui/icons-material/Refresh'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

interface Props {
  /** Short code matching the console log entry, so a report can be traced. */
  reference?: string
  onRetry?: () => void
}

/**
 * What an operator sees when a screen fails to render.
 *
 * No exception message, no stack, no bundle path, no source location. Those
 * describe the platform's internals to somebody whose job is running it, and
 * on a shared console they are also a description of the software to anybody
 * who can see the screen.
 *
 * What is left is the part that is actually true and useful: nothing they were
 * looking at has changed, the rest of the console still works, and here is a
 * reference to quote.
 */
export function ErrorPanel({ reference, onRetry }: Props) {
  return (
    <Box sx={{ display: 'grid', placeItems: 'center', p: 4 }}>
      <Paper variant="outlined" sx={{ p: 4, maxWidth: 560, width: '100%' }} role="alert">
        <Typography variant="h2" gutterBottom>
          مشکلی در نمایش این بخش پیش آمد
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          اطلاعات شما تغییری نکرده است. دوباره تلاش کنید.
        </Typography>

        <Stack direction="row" spacing={2}>
          {onRetry ? (
            <Button variant="contained" startIcon={<RefreshIcon />} onClick={onRetry}>
              تلاش مجدد
            </Button>
          ) : null}
          <Button variant="outlined" href="/">
            بازگشت به داشبورد
          </Button>
        </Stack>

        {reference ? (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 3 }}>
            کد پیگیری:{' '}
            <Box component="span" sx={{ fontFamily: 'monospace' }} dir="ltr">
              {reference}
            </Box>
          </Typography>
        ) : null}
      </Paper>
    </Box>
  )
}
